












import { defineComponent } from '@nuxtjs/composition-api';
import * as Yt from '@shared/helpers/videoEmbeddings/youtube';

import Container from '~/components/Container.vue';

import SectionTitle from '../SectionTitle.vue';

export default defineComponent({
  name: 'FeaturedYoutubeVideo',
  components: {
    SectionTitle,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Yt,
    };
  },
});
